// extracted by mini-css-extract-plugin
module.exports = {"amp-config-title":"colors-config_amp-config-title__caMbi","amp-config-description":"colors-config_amp-config-description__jYOIN"};